import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import * as Icons from "lucide-react";

const accentMap = {
  xp: "text-tc-xp bg-tc-xp/10 border-tc-xp/30",
  mastery: "text-tc-mastery bg-tc-mastery/10 border-tc-mastery/30",
  coach: "text-tc-coach bg-tc-coach/10 border-tc-coach/30",
  pass: "text-tc-pass bg-tc-pass/10 border-tc-pass/30",
};
const iconFor = (name) => {
  const key = name.split("-").map((p, i) => i === 0 ? p[0].toUpperCase() + p.slice(1) : p[0].toUpperCase() + p.slice(1)).join("");
  return Icons[key] || Icons.Award;
};

export default function Achievements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/achievements").then((r) => setItems(r.data.achievements)); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-5xl mx-auto space-y-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Achievements</h1>
        <p className="text-tc-sub mt-1">Earned through discipline and process — not profit.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((a) => {
          const Icon = iconFor(a.icon);
          return (
            <div key={a.id} data-testid={`achievement-${a.id}`}
              className={`tc-card p-5 ${a.unlocked ? "" : "opacity-45 grayscale"}`}>
              <div className={`w-11 h-11 rounded-xl border flex items-center justify-center ${accentMap[a.accent] || accentMap.xp}`}>
                <Icon className="w-6 h-6" />
              </div>
              <div className="font-heading font-semibold mt-3">{a.title}</div>
              <div className="text-sm text-tc-sub mt-1">{a.description}</div>
              <div className={`text-[11px] font-mono mt-2 ${a.unlocked ? "text-tc-bull" : "text-tc-muted"}`}>{a.unlocked ? "UNLOCKED" : "LOCKED"}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
